<template>
  <v-list-item
    class="flow-navigation-path"
    @click="emit('select')"
  >
    <div class="flow-navigation-path__title">
      <span
        class="flow-navigation-path__condition"
        :class="{ 'flow-navigation-path__condition--strike': path.status === 'inactive' || ruleStatus === 'inactive' }"
      >
        <ui-icon size="14" icon="far fa-circle"></ui-icon>
        <span class="pl-4">{{ pathName }}</span>
      </span>
      <span class="flow-navigation-path__meta">
        <span
          class="pr-4"
          v-if="path.status === 'active' && ruleStatus !== 'inactive'"
        >{{ percentName }}</span>
        <ui-icon
          size="14"
          class="flow-play-g"
          v-if="path.status === 'active' && ruleStatus !== 'inactive'"
          icon="fas fa-play"
        ></ui-icon>
        <ui-icon
          size="14"
          :color="$colors.gray40"
          v-if="path.status === 'inactive' || ruleStatus === 'inactive'"
          icon="fas fa-pause"
        ></ui-icon>
      </span>
    </div>
  </v-list-item>
</template>

<script setup lang="ts">
import { useColors } from '@/composables';
import { useFlowNavigationPath } from './useFlowNavigationPath';

const $colors = useColors();

const props = defineProps<{
  path: {
    name?: string;
    weight: number;
    status?: string;
  };
  paths: Array<{
    name?: string;
    weight: number;
    status?: string;
  }>;
  ruleStatus?: string;
  ruleIndex: number;
  pathIndex: number;
  activeItem?: unknown;
}>();

const emit = defineEmits<{
  select: [];
}>();

const { pathName, percentName } = useFlowNavigationPath(props);
</script>

<style lang="scss">
.flow-navigation-path {
  &__title {
    flex-wrap: nowrap;
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    white-space: nowrap;
  }

  &__meta {
    flex: 0 0 auto;
    margin-left: auto;
    display: inline-flex;
    align-items: center;
  }

  &__condition {
    flex: 1 1 auto;
    min-width: 0;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;

    &--strike {
      color: var(--color-gray40);
      text-decoration: line-through;
      text-decoration-line: line-through;
    }
  }
}
</style>
